import styled from 'styled-components';
import { interpolate } from 'app/shared/components/RangeControl/utils';

export const DonutSt = styled.svg.attrs({
  viewBox: '0 0 42 42',
})`
  width: 12.5rem;
`;

interface Props {
  value: number;
  max: number;
}

export const CircleSt = styled.circle.attrs<Props>({
  cx: 21,
  cy: 21,
  r: 14.8,
})<Props>`
  fill: transparent;
  stroke: ${({ theme }) => theme.colors.primary};
  stroke-linecap: round;
  stroke-width: 1.4;
  stroke-dasharray: ${({ value, max }) => interpolate(value, 0, max, 0, 70)},
    100;
  opacity: 1;
  transform-origin: center center;
  transform: rotate(134deg);
`;

interface ImageProps {
  value: number;
  max: number;
}

export const ArrowSt = styled.img.attrs<ImageProps>({
  src: '/assets/images/rating-score-arrow.png',
})<ImageProps>`
  position: absolute;
  width: 100%;
  transform: ${({ value, max }) =>
    `rotate(${interpolate(value, 0, max, -245, 25)}deg) `};
`;
